export default {
  getAttachments: state => state.emailManagerState.attachments,
  getEmailTemplates: state => state.emailTemplates.filter(template => template.type.includes(process.env.VUE_APP_TENENT)),
  getAllAccounts: state => state.emailManagerState.allAccounts,
  getEmailResponse: state => state.emailManagerState.emailResponse,
  getAccountEmail: state => state.emailManagerState.accountEmail,
  getUnassignedEmailCount: state => state.emailManagerState.unassignedEmailCount,
  getEmailTemplatesWithLetters: state => state.emailTemplatesWithLetters,
};
